export function getTime(dateString: string | Date): string {
  if (!dateString) return "";
  const date = new Date(dateString);
  const hours = date.getHours() > 9 ? date.getHours() : "0" + date.getHours();
  const minutes =
    date.getMinutes() > 9 ? date.getMinutes() : "0" + date.getMinutes();
  const fullTime = `${hours}:${minutes}`;
  return fullTime;
}

export function getDate(dateString: string | Date): string {
  if (!dateString) return "";
  const date = new Date(dateString);
  const fullDate = `${
    date.getDate() > 9 ? date.getDate() : "0" + date.getDate()
  }.${
    date.getMonth() + 1 > 9 ? date.getMonth() + 1 : "0" + (date.getMonth() + 1)
  }.${+date.getFullYear()}`;

  const fullTime = getTime(dateString);
  return fullDate + " " + fullTime;
}
export function getBirthday(dateString: string | Date): string {
  if (!dateString) return "";
  const b = new Date(dateString);

  const d = b.getDate() > 9 ? b.getDate() : "0" + b.getDate();
  const m = b.getMonth() + 1 > 9 ? b.getMonth() + 1 : "0" + (b.getMonth() + 1);
  const y = b.getFullYear();
  return `${d}.${m}.${y}`;
}
export function getAge(dateString: string | Date): number {
  const now = new Date();
  const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
  const dob = new Date(dateString); //Дата рождения
  const dobnow = new Date(today.getFullYear(), dob.getMonth(), dob.getDate()); //ДР в текущем году
  let age; //Возраст

  //Возраст = текущий год - год рождения
  age = today.getFullYear() - dob.getFullYear();
  //Если ДР в этом году ещё предстоит, то вычитаем из age один год
  if (today < dobnow) {
    age = age - 1;
  }
  return age;
}
